
import {
  PEImmigrationBenefitsCardActions, PEImmigrationBenefitsCardGetters, PEImmigrationBenefitsCardMutations,
} from './pe-immigration-benefits-card'
import {
  PEImmigrationProceedingsCardActions, PEImmigrationProceedingsCardGetters, PEImmigrationProceedingsCardMutations,
} from './pe-immigration-proceedings-card'
import { PEIncomeCardActions, PEIncomeCardGetters, PEIncomeCardMutations } from './pe-income-card'
import { PELanguagesCardActions, PELanguagesCardGetters, PELanguagesCardMutations } from './pe-languages-card'

export const BackgroundSectionActions = {
  ...PEImmigrationBenefitsCardActions,
  ...PEImmigrationProceedingsCardActions,
  ...PEIncomeCardActions,
  ...PELanguagesCardActions,
}

export const BackgroundSectionGetters = {
  ...PEImmigrationBenefitsCardGetters,
  ...PEImmigrationProceedingsCardGetters,
  ...PEIncomeCardGetters,
  ...PELanguagesCardGetters,
}

export const BackgroundSectionMutations = {
  ...PEImmigrationBenefitsCardMutations,
  ...PEImmigrationProceedingsCardMutations,
  ...PEIncomeCardMutations,
  ...PELanguagesCardMutations,
}
